import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSchool, faPeopleRoof, faHandHoldingHeart, faBookReader } from '@fortawesome/free-solid-svg-icons';

const DiferenciaisSection = () => (
  <section className="extra-info">
    <h2>Nossos Diferenciais</h2>
    <div className="info-cards">
      <div className="info-card">
        <FontAwesomeIcon icon={faBookReader} className="icon" />
        <h3>Atividades Extracurriculares</h3>
        <p>Além do currículo básico, oferecemos aulas de robótica, música, esportes e mais, proporcionando uma educação completa.</p>
      </div>
      <div className="info-card">
        <FontAwesomeIcon icon={faHandHoldingHeart} className="icon" />
        <h3>Foco no Desenvolvimento Emocional</h3>
        <p>Sabemos que a formação de caráter e emoções é essencial. Por isso, investimos em programas que ajudam no desenvolvimento social e emocional.</p>
      </div>
      <div className="info-card">
        <FontAwesomeIcon icon={faPeopleRoof} className="icon" />
        <h3>Parceria com Pais</h3>
        <p>Trabalhamos em conjunto com os pais para garantir o melhor acompanhamento pedagógico e desenvolvimento de cada aluno.</p>
      </div>
      <div className="info-card">
        <FontAwesomeIcon icon={faSchool} className="icon" />
        <h3>Infraestrutura Moderna</h3>
        <p>Criamos ambientes que estimulam uma aprendizagem dinâmica e integrada à tecnologia.</p>
      </div>
    </div>
  </section>
);

export default DiferenciaisSection;
